import { cn } from '@/lib/utils';

type Props = {
  value: number | null;
  className?: string;
};

export function PerfCell({ value, className }: Props) {
  if (value == null) return <span className={cn('text-subtle', className)}>—</span>;
  const sign = value >= 0 ? '+' : '';
  const color = value >= 0 ? 'text-accent' : 'text-accent-danger';
  return <span className={cn('tabular-nums', color, className)}>{sign}{value.toFixed(1)}%</span>;
}
